import { Components } from "@thisgorilla/primate-ds";

import { FlexColumn } from "../../../../Common/Styles";
import CardLayout from "./CardLayout";

export const Posts = () => {
  return (
    <CardLayout title="Posts">
      <FlexColumn $gapInPx={8}>
        <Components.ListItem
          label="Drafts"
          type="List Item"
          onClick={() => {}}
          iconType="Edit"
          count="5"
          countColor="Light"
        />
        <Components.ListItem
          label="Scheduled posts"
          type="List Item"
          onClick={() => {}}
          iconType="Calendar"
          count="5"
          countColor="Light"
        />
      </FlexColumn>
    </CardLayout>
  );
};
